import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";

type VerificationInfoProps = {
  isLoading?: boolean;
  verificationCode: string;
  setVerificationCode: (code: string) => void;
  setCurrentStep?: (step: number) => void;
  handleFormSubmit?: () => void;
  imageMatch?: string;
};

const VerificationInfo: React.FC<VerificationInfoProps> = ({
  isLoading,
  setCurrentStep,
  imageMatch,
  handleFormSubmit
}) => {
  const { t } = useTranslation();
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token);
  };

  return (
    <>
      <div className="flex flex-col justify-center items-center gap-4">
        <div className="bg-primary-lightblue py-2 px-4 rounded-lg w-full">
          <p className="text-primary-blue text-base font-bold">
            {t("registration_form.review_profile.section5_rule")}
          </p>
        </div>

        {/* QR Code */}
        {/* <div className="w-full flex justify-center items-center">
          <Image src={qr} width={400} height={100} preview={false} />
        </div> */}

        {/* Input & Refresh Button */}
        {/* <div className="md:w-[400px] w-full">
          <div className="relative">
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-blue focus:border-primary-blue"
              placeholder={t("registration_form.review_profile.section5_hint")}
            />
            <button
              type="button"
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <RefreshCw size={20} />
            </button>
          </div>
        </div> */}

        {/* reCAPTCHA */}
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
          onChange={handleCaptchaChange}
        />
      </div>
      <div className="flex w-full justify-center items-center">
        <div className="max-w-[400px] flex max-sm:flex-col gap-4 mt-8 w-full justify-center items-center">
          <button
            className="w-full flex-1 py-4 px-6 border-2 font-bold border-primary-blue rounded-3xl text-primary-blue hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            onClick={() => setCurrentStep?.(1)}
          >
            {t("registration_form.back")}
          </button>
          <button
            className={`w-full flex-1 py-4 px-6 border font-bold border-transparent rounded-3xl text-primary-blue flex justify-center items-center ${
              !captchaToken ||
              (imageMatch && imageMatch === "-1" ? true : false)
                ? "bg-gray-500 text-white"
                : "bg-primary-lightyellow hover:bg-primary-yellow duration-200"
            }`}
            onClick={() => {setCurrentStep?.(3)
              handleFormSubmit?.();
            }}
            disabled={
              !captchaToken ||
              (imageMatch && imageMatch === "-1" ? true : false)
            }
          >
            {isLoading && (
              <div className="w-6 h-6 mr-2 border-4 border-t-primary-blue border-gray-300 rounded-full animate-spin"></div>
            )}
            {t("registration_form.continue")}
          </button>
        </div>
      </div>
    </>
  );
};

export default VerificationInfo;
